import { SectionTitle } from "@/components/molecules";
import { PageContainer } from "@/components/organisms";
import { COLOR_CODE } from "@/utils/constants/colors";

const Section = ({ id, title }) => {
  return <SectionTitle id={id} label={title} />;
};

const InfoItem = ({label, value, isHighlighted}) => (
  <div className="col-span-1 pt-4">
    <span className="key text-sm" style={{color: COLOR_CODE._D0D0D0}}>
      {label}
    </span>
    <h2 className="val text-base font-bold" style={isHighlighted ? {color: COLOR_CODE._3387DF} : {}}>
      {value !== undefined && value !== null && value !== '' ? value : '-'}
    </h2>
  </div>
)

const DisplayInformation = ({orderDetails}) => {
  const locationDetails = [
    {label: 'Order Location ID', value: orderDetails?.orderLocationId},
    {label: 'Alternative Location ID', value: orderDetails?.alternativeLocationId},
    {label: 'Visit Schedule ID', value: orderDetails?.visitScheduleId},
    {label: 'Customer GTMU', value: orderDetails?.customerGTMU},
    {label: 'Customer PO ID', value: orderDetails?.customerPoId},
    {label: 'Country ISO Code', value: orderDetails?.countryIsoCode},
  ]

  return (
    <>
      <div className="order-overview">
        <div className="sc-border grid pl-4">
          <Section id="location_info" title="Customer and Location Details" />
        </div>
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          {locationDetails.map(item => (
            <InfoItem key={item.label} label={item.label} value={item.value} />
          ))}
        </div>
      </div>
    </>
  )
}

const OfflineOrderSoldToPage = ({ OrderDetails }) => {
  return (
    <PageContainer>
      <DisplayInformation orderDetails={OrderDetails} />
    </PageContainer>
  );
};

export default OfflineOrderSoldToPage;